import Swal from "sweetalert2";
import "animate.css";
import { postNotification } from "../../apis/apiService";


export const showPasswordReminderPopup = async (
  message,
  user_id,
  is_read,
  notification_id,
  navigate
) => {
  const result = await Swal.fire({
    title: "⚠️ Password Change Recommended",
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Change Password",
    cancelButtonText: "Remind Me Later",
    draggable: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showClass: {
      popup: `
      animate__animated
      animate__fadeInUp
      animate__faster
    `,
    },
    hideClass: {
      popup: `
      animate__animated
      animate__fadeOutDown
      animate__faster
    `,
    },
  });

  if (result.isDismissed) {
    const response = await postNotification(
      "show-password-expiry-notification",
      notification_id
    );
    await Swal.fire({
      icon: "success",
      text: response.message,
    });
  }
  
  if (result.isConfirmed) {
    await postNotification(
      "show-password-expiry-notification",
      notification_id
    );
    navigate("/change-password");
  }
};
